import React from "react";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import {DownloadButton} from "../../../download-button/DownloadButton.tsx";

export const DownloadFileCell: React.FC<DeserializedGridCellParams<PartGridRowModel>> = (props) => {
    const partId = props.row.part;
    const part = props.row.related_part;
    const pId = props.row.p_id;
    if (part?.file_name && partId && pId) {
        return <DownloadButton filename={part.file_name} part_id={partId} p_id={pId}/>
    }
    return null;
}
